import api from '@/api';
import { API_BASE_URL } from '..';
import {
  WorkOrderImportAudatexwebForm,
  WorkOrderImportCiliaForm,
  WorkOrderImportResponse,
  WorkorderImportDataRequest,
  WorkOrderImportLocalizaForm,
  WorkOrderImportSoma,
  WorkOrderImportI360,
  WorkOrderImportCreateResponse,
  InsuranceClaim,
  ImportGetUpdateCiliaListResponse,
  ImportGetUpdateCiliaRequest,
  ImportGetUpdateCiliaResponse,
} from './WorkOrderImports.types';

const CONTROLLER_URL = `${API_BASE_URL}/workorders/imports`;

export async function getImportCilia(params: WorkOrderImportCiliaForm) {
  const result = (await api.get(`${CONTROLLER_URL}/cilia`, params)) as unknown;

  return result as WorkOrderImportResponse;
}

export async function getImportSoma(data: WorkOrderImportSoma) {
  const result = (await api.post(`${CONTROLLER_URL}/soma`, data)) as unknown;

  return result as WorkOrderImportResponse;
}

export async function getImportI360(data: WorkOrderImportI360) {
  const result = (await api.post(`${CONTROLLER_URL}/i360`, data)) as unknown;

  return result as WorkOrderImportResponse;
}

export async function getImportAudatexweb(
  params: WorkOrderImportAudatexwebForm,
) {
  const result = (await api.get(
    `${CONTROLLER_URL}/audatexweb`,
    params,
  )) as unknown;

  return result as WorkOrderImportResponse;
}

export async function getImportLocaliza(params: WorkOrderImportLocalizaForm) {
  const result = (await api.get(
    `${CONTROLLER_URL}/localiza`,
    params,
  )) as unknown;

  return result as WorkOrderImportResponse;
}

export async function workorderImportCreate(data: WorkorderImportDataRequest) {
  const result = (await api.post(`${CONTROLLER_URL}/`, data)) as unknown;

  return result as WorkOrderImportCreateResponse;
}

export async function workorderValidateImportReplace(
  workOrderComplementId: number,
) {
  const result = (await api.get(`${CONTROLLER_URL}/ValidateImportReplace`, {
    workOrderComplementId,
  })) as unknown;

  return result as void;
}

export async function workorderImportFromJson(params: InsuranceClaim) {
  const result = (await api.post(
    `${CONTROLLER_URL}/import-workorder-from-json`,
    { ...params },
  )) as unknown;

  return result as WorkOrderImportResponse;
}

export async function workorderImportUpdateCiliaList(complementId: number) {
  const result = (await api.get(
    `${CONTROLLER_URL}/get-update-cilia/${complementId}`,
    {},
  )) as unknown;

  return result as ImportGetUpdateCiliaListResponse;
}

export async function workorderImportUpdateCilia(
  params: ImportGetUpdateCiliaRequest,
) {
  const result = (await api.post(
    `${CONTROLLER_URL}/update-cilia`,
    params,
  )) as unknown;

  return result as ImportGetUpdateCiliaResponse;
}
